import { toDate as e } from "./toDate.js";
function c(t) {
  return e(t).getSeconds();
}
export {
  c as default,
  c as getSeconds
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/getSeconds.js
// module id = 886
// module chunks = 67